import { useState, useEffect } from "react";
import api from "../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const AddFechasSeguimiento = () => {
    // ESTADOS //
    const [IdPersona, setIdPersona] = useState("");
    const [personas, setPersonas] = useState([]);
    const [fechaActual, setFechaActual] = useState("");
    const [fechaSintomas, setFechaSintomas] = useState("");
    const [desconoceFechaSintomas, setDesconoceFechaSintomas] = useState(false);
    const [fechaExposicion, setFechaExposicion] = useState("");
    const [desconoceFechaExposicion, setDesconoceFechaExposicion] = useState(false);
    const [fechaConsulta, setFechaConsulta] = useState("");
    const [desconoceFechaConsulta, setDesconoceFechaConsulta] = useState(false);
    const [mensaje, setMensaje] = useState("");
    // FIN ESTADOS //

    const navigate = useNavigate();

    // USE EFFECT //
    useEffect(
        () => {
            leerPersonas();
            FechaHoy();
        },
        []
    );
    // FIN USE EFFECT //

    // CONSULTAS SQL //
    const leerPersonas = async () => {
        try {
                const response = await api.get(`/leerPersonas`);
            setPersonas(response.data);
        } catch (error) {
            console.error(error.message);
        }
    };

    const handleGuardarFechas = async (e) => {
        e.preventDefault();

        try {
            await api.post(`/guardarFechasSeguimiento`, {
                IdPersona,
                fechaSintomas: desconoceFechaSintomas ? null : fechaSintomas,
                fechaExposicion: desconoceFechaExposicion ? null : fechaExposicion,
                fechaConsulta: desconoceFechaConsulta ? null : fechaConsulta,
            });
            setMensaje("Fechas de seguimiento guardadas con éxito.");
            setIdPersona("");
            setFechaSintomas("");
            setDesconoceFechaSintomas(false);
            setFechaExposicion("");
            setDesconoceFechaExposicion(false);
            setFechaConsulta("");
            setDesconoceFechaConsulta(false);
        } catch (error) {
            console.error(error);
            setMensaje("Error al guardar las fechas de seguimiento.");
        }
    };
    // FIN CONSULTAS SQL //

    // FUNCIONES //
    const FechaHoy = async () => {
        var today = new Date();
        // `getDate()` devuelve el día del mes (del 1 al 31)
        var day = today.getDate();
        // `getMonth()` devuelve el mes (de 0 a 11)
        var month = today.getMonth() + 1;
        // `getFullYear()` devuelve el año completo
        var year = today.getFullYear();
        // `getHours()` devuelve la hora
        var horaAux = today.getHours();
        // `getMinutes()` devuelve los minutos
        var minutosAux = today.getMinutes();
        // `getSeconds()` devuelve los segundos
        var segundosAux = today.getSeconds();
        var hora = horaAux.toString().padStart(2, "0");
        var minutos = minutosAux.toString().padStart(2, "0");
        var segundos = segundosAux.toString().padStart(2, "0");
        // muestra la fecha de hoy en formato `MM/DD/YYYY`
        //console.log(`${month}/${day}/${year}`);
        setFechaActual(`${year}-${month}-${day}`);
        //setHora(`${hora}:${minutos}:${segundos}`);
    };
    // FIN FUNCIONES //

    // RENDERIZADO EN PANTALLA //
    return (
        <div className="columns mt-5 is-centered">
            <div className="column is-half">
                <label className="label">Agregar Fechas Seguimiento</label>
                <br />
                {mensaje && <div className="notification is-primary">{mensaje}</div>}
                <form onSubmit={handleGuardarFechas}>
                    <div className="field">
                        <label className="label">Persona</label>
                        <div className="select is-fullwidth">
                            <select
                                value={IdPersona}
                                onChange={(e) => setIdPersona(e.target.value)}
                                required
                            >
                                <option value="">Seleccionar</option>
                                {personas.map((persona) => (
                                    <option value={persona.IdPersona} key={persona.IdPersona}>
                                        {persona.Nombre} {persona.Apellido}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="field">
                        <label className="label">Seleccione la fecha de probable exposición</label>
                        <div className="control">
                            <input
                                type="date"
                                className="input"
                                value={fechaExposicion}
                                onChange={(e) => setFechaExposicion(e.target.value)}
                                disabled={desconoceFechaExposicion || !IdPersona}
                                style={{ backgroundColor: desconoceFechaExposicion || !IdPersona ? "#e0e0e0" : "white" }}
                                max={fechaActual}
                            />
                            <label className="checkbox ml-2">
                                <input
                                    type="checkbox"
                                    checked={desconoceFechaExposicion}
                                    onChange={(e) => setDesconoceFechaExposicion(e.target.checked)}
                                    disabled={!IdPersona}
                                />{" "}
                                Se desconoce la fecha
                            </label>
                        </div>
                    </div>

                    <div className="field">
                        <label className="label">Seleccione la fecha de inicio de síntomas</label>
                        <div className="control">
                            <input
                                type="date"
                                className="input"
                                value={fechaSintomas}
                                onChange={(e) => setFechaSintomas(e.target.value)}
                                disabled={desconoceFechaSintomas || !IdPersona}
                                style={{ backgroundColor: desconoceFechaSintomas || !IdPersona ? "#e0e0e0" : "white" }}
                                max={fechaActual}
                            />
                            <label className="checkbox ml-2">
                                <input
                                    type="checkbox"
                                    checked={desconoceFechaSintomas}
                                    onChange={(e) => setDesconoceFechaSintomas(e.target.checked)}
                                    disabled={!IdPersona}
                                />{" "}
                                Se desconoce la fecha
                            </label>
                        </div>
                    </div>



                    <div className="field">
                        <label className="label">Seleccione la fecha de primera consulta</label>
                        <div className="control">
                            <input
                                type="date"
                                className="input"
                                value={fechaConsulta}
                                onChange={(e) => setFechaConsulta(e.target.value)}
                                disabled={desconoceFechaConsulta || !IdPersona}
                                style={{ backgroundColor: desconoceFechaConsulta || !IdPersona ? "#e0e0e0" : "white" }}
                                max={fechaActual}
                            />
                            <label className="checkbox ml-2">
                                <input
                                    type="checkbox"
                                    checked={desconoceFechaConsulta}
                                    onChange={(e) => setDesconoceFechaConsulta(e.target.checked)}
                                    disabled={!IdPersona}
                                />{" "}
                                Se desconoce la fecha
                            </label>
                        </div>
                        {/*
                        probable exposición: {fechaExposicion}
                        <br/>
                        probable síntomas: {fechaSintomas}
                        <br/>
                        probable consulta: {fechaConsulta}
                        */}
                    </div>

                    <div className="level">
                        <div className="level-left">
                            <button type="button" className="button is-link" onClick={() => navigate(-1)}>
                                Volver
                            </button>
                        </div>
                        <div className="level-right">
                            <button type="submit" className="button is-primary">
                                Guardar <FontAwesomeIcon icon={faCheck} />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
    // FIN RENDERIZADO EN PANTALLA //
};

export default AddFechasSeguimiento;
